
























































import {
    GroupTreeItem,
    SetUserGroupTreeItem,
    SetUserTradingNetworkTreeItem,
    TradingNetworkTreeItem,
    UserTradingNetworkTreeItem,
} from '@/interfaces/server-data';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import Http from '../mixins/http';

@Component({})
export default class UserCategories extends Mixins(Http, Toast, LocalData) {
    @Prop() tagTree!: TradingNetworkTreeItem[];
    @Prop() userTagTree!: UserTradingNetworkTreeItem[];
    @Prop() userId!: number;

    setUserTags() {
        const setUserTagsTree: SetUserTradingNetworkTreeItem[] = this.tagTree.map((tn) => ({
            id: tn.id,
            groups: this.mapGroups(tn.groups),
            checked: tn.checked,
        }))
        this.httpSetUserTags(this.userId, setUserTagsTree)
    }

    private mapGroups(groups: GroupTreeItem[]): SetUserGroupTreeItem[] {
        return groups.map((g) => ({
            id: g.id,
            categoryIds: g.categories.filter((c) => c.isChecked).map((c) => c.id),
            checked: g.checked,
        }))
    }

    private getGroups(tradingNetwork: TradingNetworkTreeItem) {
        if (tradingNetwork.groups.length === 0) {
            tradingNetwork.isLoading = true;
            this.httpGetGroups(tradingNetwork.id)
                    .then((r) => {
                        tradingNetwork.groups = r.data.map((g) => ({
                            id: g.id,
                            name: g.name,
                            categories: [],
                            isOpen: false,
                            checked: this.getCheckedForGroup(tradingNetwork, g.id),
                            key: Math.random(),
                            isLoading: true,
                        }))
                        tradingNetwork.key = Math.random();
                        tradingNetwork.isLoading = false;
                    })
                    .catch((e) => {
                        this.showError(this.$t('shared.messages.loadGroupsError') as string);
                        tradingNetwork.isLoading = false;
                    });
        }
    }

    private getCategories(tnId: number, group: GroupTreeItem) {
        if (group.categories.length === 0) {
            group.isLoading = true;
            this.httpGetCategories(tnId, group.id)
                    .then((r) => {
                        group.categories = r.data.map((c) => ({
                            id: c.id,
                            name: c.name,
                            isChecked: this.getCheckedForCategory(group, c.id),
                        }))
                        group.key = Math.random()
                        group.isLoading = false;
                    })
                    .catch((e) => {
                        this.showError(this.$t('shared.messages.loadGroupsError') as string);
                        group.isLoading = false;
                    });
        }
    }

    private getCheckedForGroup(tradingNetwork: TradingNetworkTreeItem, groupId: number): number {
        if (tradingNetwork.checked === 1) {
            const userGroup = this.userTagTree
                    .find((tn) => tn.id === tradingNetwork.id)!
                    .groups
                    .find((g) => g.id === groupId)
            if (userGroup == null) {
                return 0;
            } else {
                return userGroup.isChecked ? 2 : 1
            }
        } else {
            return tradingNetwork.checked
        }
    }

    private getCheckedForCategory(group: GroupTreeItem, categoryId: number): boolean {
        if (group.checked === 1) {
            return this.userTagTree
                    .flatMap((tn) => tn.groups)
                    .find((g) => g.id === group.id)!
                    .categoryIds
                    .includes(categoryId)
        } else {
            return group.checked === 2
        }
    }

    private onTradingNetworkChecked(isChecked: boolean, tradingNetwork: TradingNetworkTreeItem) {
        if (isChecked) {
            tradingNetwork.groups.forEach((g) => {
                this.onGroupChecked(true, g, tradingNetwork)
            });
            tradingNetwork.checked = 2;
        } else {
            tradingNetwork.groups.forEach((g) => {
                this.onGroupChecked(false, g, tradingNetwork)
            });
            tradingNetwork.checked = 0;
        }
    }

    private onGroupChecked(isChecked: boolean, group: GroupTreeItem, tradingNetwork: TradingNetworkTreeItem) {
        if (isChecked) {
            group.categories.forEach((c) => c.isChecked = true);
            group.checked = 2;
        } else {
            group.categories.forEach((c) => c.isChecked = false);
            group.checked = 0;
        }
        const checkedGroups = tradingNetwork.groups.filter((g) => g.checked === 2).length
        if (checkedGroups === 0) {
            tradingNetwork.checked = 0;
        } else if (0 < checkedGroups && checkedGroups < tradingNetwork.groups.length) {
            tradingNetwork.checked = 1;
        } else if (checkedGroups === tradingNetwork.groups.length) {
            tradingNetwork.checked = 2;
        }
    }

    private onCategoryChecked(group: GroupTreeItem, tradingNetwork: TradingNetworkTreeItem) {
        const checkedCategories = group.categories.filter((c) => c.isChecked).length;
        if (checkedCategories === 0) {
            this.onGroupChecked(false, group, tradingNetwork)
        } else if (0 < checkedCategories && checkedCategories < group.categories.length) {
            group.checked = 1;
            tradingNetwork.checked = 1;
        } else if (checkedCategories === group.categories.length) {
            this.onGroupChecked(true, group, tradingNetwork)
        }

    }
}
